// extracted by mini-css-extract-plugin
module.exports = {"addWrap":"Levels_addWrap__1J1So","addNew__icon":"Levels_addNew__icon__9XPCi","addNew__text":"Levels_addNew__text__du_g9","goBack__icon":"Levels_goBack__icon__mFOjV"};